<template>
  <div>
    <div class="weituo">
      <div style="display: flex">
        <i class="el-icon-box" style="color: #63b947; font-size: 25px"></i>
        <p class="tittype">{{ $t("i18n_product_information") }}</p>
        <p class="tittype" style="font-weight: 500; color: #f56c6c">
          {{ $t("货值数据具有法律效应,请认真填写") }}
        </p>
      </div>
      <!-- <div class="addMore">
        <el-button
          type="text"
          size="medium"
          @click="addItem"
          icon="el-icon-circle-plus"
        >增加更多</el-button>
      </div> -->
    </div>
    <!-- <div v-for="(item, index) in goodsInfoForm.GoodsList" :key="index">
      <el-form label-position="right" label-width="106px" size="small" :model="goodsInfoForm.GoodsList[index]" ref="goodsForm" :rules="goodsInfoFormRules">
        <div>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="品名" prop="goodsname">
                <el-input v-model="item.goodsname" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="货物类型" prop="goodsTypeId">
                <el-select v-model="item.goodsTypeId" style="width: 100%" @change="getHTFcount">
                  <el-option
                    v-for="item in goodsTypeOptions"
                    :key="item.id"
                    :label="item.cnName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否品牌" prop="isBrand">
                <el-radio-group size="mini" v-model="item.isBrand" style="width: 100%">
                  <el-radio-button :label="true">是</el-radio-button>
                  <el-radio-button :label="false">否</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否带电" prop="isHasBattery">
                <el-radio-group size="mini" v-model="item.isHasBattery" style="width: 100%">
                  <el-radio-button :label="true">是</el-radio-button>
                  <el-radio-button :label="false">否</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否液体粉末" prop="isPowderLiquid">
                <el-radio-group size="mini" v-model="item.isPowderLiquid" style="width: 100%">
                  <el-radio-button :label="true">是</el-radio-button>
                  <el-radio-button :label="false">否</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="件数" prop="piece">
                <el-input v-model.number="item.piece" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="重量" prop="weight">
                <el-input
                  v-model="item.weight"
                  @change="getTimoney(),getHTFcount()"
                  style="width: 100%"
                >
                  <i slot="suffix">KG</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row style="width: 100%">
                <el-col :span="13">
                  <el-form-item label="尺寸(cm)" prop="l">
                    <el-input style="width: 100%" v-model.number="item.l">
                      <i
                        slot="suffix"
                        style="margin-top: 5px; display: inline-block;"
                      >长</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="" label-width="0" style="margin: 0" prop="w">
                    <el-input style="width: 100%" v-model.number="item.w">
                      <i
                        slot="suffix"
                        style="margin-top: 5px; display: inline-block;"
                      >宽</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item style="margin: 0" prop="h" label-width="0">
                    <el-input style="width: 108%" v-model.number="item.h">
                      <i
                        slot="suffix"
                        style="margin-top: 5px; display: inline-block;"
                      >高</i>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体积">
                <el-input
                  v-model="item.cbm"
                  style="width: 100%"
                  disabled
                >
                  <i slot="suffix">CBM</i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="width: 100%">
            <el-button
              icon="el-icon-delete"
              size="mini"
              style="background: #eeeeee"
              @click="handleDelete(index)"
              v-if="goodsInfoForm.GoodsList.length>1"
            >删除</el-button>
          </div>
          <el-divider v-if="goodsInfoForm.GoodsList.length>1"></el-divider>
        </div>
      </el-form>
    </div> -->
    <el-form
      ref="goodsForm"
      :model="addGoodsForm"
      :rules="goodsInfoFormRules"
      size="small"
      class="small"
    >
      <el-table
        border
        :data="addGoodsForm.GoodsList"
        :header-cell-style="{ background: '#f6f6f6' }"
      >
        <!-- <el-table-column
          label="序号"
          width="50"
          type="index"
          align="center"
          fixed="left"
        ></el-table-column> -->
        <el-table-column :label="$t('i18n_product_name')" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList[${scope.$index}].goodsname`"
              :rules="goodsInfoFormRules.goodsname"
            >
              <el-input v-model="scope.row.goodsname" class="center"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column :label="$t('i18n_product_name_en')" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList[${scope.$index}].namee`"
              :rules="goodsInfoFormRules.goodsname"
            >
              <el-input v-model="scope.row.namee" class="center"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="货物类型"
          align="center"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList.${scope.$index}.goodsTypeId`"
              :rules="goodsInfoFormRules.goodsTypeId"
            >
              <el-select v-model="scope.row.goodsTypeId" style="width: 100%" @change="goodTypechange" placeholder="">
                <el-option
                  v-for="item in goodsTypeOptions"
                  :key="item.id"
                  :label="item.cnName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('i18n_brands')" align="center" width="60px">
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList.${scope.$index}.isBrand`"
              :rules="goodsInfoFormRules.isBrand"
            >
              <el-checkbox v-model="scope.row.isBrand">{{
                $t("i18n_yes")
              }}</el-checkbox>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('i18n_elestric')"
          align="center"
          width="60px"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList.${scope.$index}.isHasBattery`"
              :rules="goodsInfoFormRules.isHasBattery"
            >
              <el-checkbox v-model="scope.row.isHasBattery">{{
                $t("i18n_yes")
              }}</el-checkbox>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('i18n_liquid_powder')"
          align="center"
          width="60px"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList.${scope.$index}.isPowderLiquid`"
              :rules="goodsInfoFormRules.isPowderLiquid"
            >
              <el-checkbox v-model="scope.row.isPowderLiquid">{{
                $t("i18n_yes")
              }}</el-checkbox>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('i18n_carton_count')"
          align="center"
          width="100px"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="`GoodsList.${scope.$index}.boxNum`"
              :rules="goodsInfoFormRules.boxNum"
            >
              <el-input
                v-model="scope.row.boxNum"
                style="width: 100%"
                :controls="false"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column :label="$t('i18n_single_box')" align="center">
          <el-table-column
            :label="$t('i18n_pcs_count')"
            align="center"
            width="80px"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`GoodsList.${scope.$index}.piece`"
                :rules="goodsInfoFormRules.piece"
              >
                <el-input
                  v-model="scope.row.piece"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('i18n_weight_kgs')"
            align="center"
            width="80px"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`GoodsList.${scope.$index}.weight`"
                :rules="goodsInfoFormRules.weight"
              >
                <el-input
                  v-model="scope.row.weight"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('i18n_length')"
            align="center"
            width="80px"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`GoodsList.${scope.$index}.l`"
                :rules="goodsInfoFormRules.l"
              >
                <el-input v-model="scope.row.l" style="width: 100%"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('i18n_wide')" align="center" width="80px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`GoodsList.${scope.$index}.w`"
                :rules="goodsInfoFormRules.w"
              >
                <el-input v-model="scope.row.w" style="width: 100%"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('i18n_height')"
            align="center"
            width="80px"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`GoodsList.${scope.$index}.h`"
                :rules="goodsInfoFormRules.h"
              >
                <el-input v-model="scope.row.h" style="width: 100%"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('单箱货值(usd)')"
            align="center"
            width="90px"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`GoodsList.${scope.$index}.goodsValue`"
                :rules="goodsInfoFormRules.goodsValue"
              >
                <el-input
                  type="number"
                  v-model.number="scope.row.goodsValue"
                  style="width: 100%"
                ></el-input>
                <!-- <el-input-number
                  style="width: 70%"
                  v-model="scope.row.goodsValue"
                  :controls="false"
                  :min="0"
                ></el-input-number> -->
              </el-form-item>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('i18n_Operation')"
          align="center"
          width="80px"
        >
          <el-button type="text" size="medium" @click="addItem">{{
            $t("i18n_add_product")
          }}</el-button>
        </el-table-column>
      </el-table>
    </el-form>
    <el-table
      border
      :data="goodsInfoForm.GoodsList"
      style="margin-top: 10px"
      :header-cell-style="{ background: '#f6f6f6' }"
      :summary-method="getSummaries"
      show-summary
    >
      <el-table-column
        :label="$t('i18n_Serial_number')"
        type="index"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('i18n_product_name')"
        prop="goodsname"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('i18n_product_name_en')"
        prop="namee"
        align="center"
        width="70px"
      ></el-table-column>
      <el-table-column
        :label="$t('i18n_product_type')"
        prop="goodsTypeName"
        align="center"
      ></el-table-column>
      <el-table-column :label="$t('i18n_brands')" align="center" width="50px">
        <template slot-scope="scope">
          {{ $t(scope.row.isBrand ? "i18n_yes" : "i18n_no") }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n_elestric')" align="center" width="50px">
        <template slot-scope="scope">
          {{ $t(scope.row.isHasBattery ? "i18n_yes" : "i18n_no") }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('i18n_liquid_powder')"
        align="center"
        width="60px"
      >
        <template slot-scope="scope">
          {{ $t(scope.row.isPowderLiquid ? "i18n_yes" : "i18n_no") }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('i18n_carton_count')"
        prop="boxNum"
        align="center"
        width="50px"
      ></el-table-column>
      <el-table-column :label="$t('i18n_single_box')" align="center">
        <el-table-column
          :label="$t('i18n_pcs_count')"
          prop="piece"
          align="center"
          width="50px"
        ></el-table-column>
        <el-table-column
          :label="$t('i18n_weight_kgs')"
          prop="weight"
          align="center"
        ></el-table-column>
        <el-table-column :label="$t('i18n_lwh')" align="center">
          <template slot-scope="scope">
            {{ scope.row.l }}×{{ scope.row.w }}×{{ scope.row.h }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('i18n_volume')"
          prop="cbm"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('单箱货值(usd)')"
          prop="goodsValue"
          align="center"
          width="90px"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        :label="$t('i18n_total_weight')"
        prop="totalweight"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('i18n_total_volume')"
        prop="totalcbm"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('i18n_Operation')"
        align="center"
        width="100px"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="danger" @click="del(scope.$index)" size="mini">{{
            $t("i18n_delete")
          }}</el-button>
          <el-button type="primary" @click="edit(scope.$index)" size="mini">{{
            $t("i18n_edit")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addPls, cannotBeEmpty } from '@/utils/placeholderI18n'
export default {
  props: {
    goodsInfoForm: {
      type: Object,
      default: {}
    },
    goodsTypeOptions: {
      type: Array,
      default: []
    }
  },
  data() {
    const pieceValidate = (rule, value, callback) => {
      if (value.length > 15 || value.length < 1) {
        callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
      } else {
        var reg = /^[1-9]\d*$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("i18n_pecies_quantity_greater_than_0")));
        } else {
          callback();
        }
      }
    }
    const weightValidate = (rule, value, callback) => {
      if (value.length > 15 || value.length < 1) {
        callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
      } else {
        var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("i18n_more_than0_two_decimal")));
        } else {
          callback();
        }
      }
    }
    const valueValidate = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error(this.$t("货值需大于0或为空")))
      }
      if (!!value) {
        if (Number(value) <= 0) {
          callback(new Error(this.$t("货值需大于0或为空")))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    const cbmValidate = (rule, value, callback) => {
      if (value.length > 15 || value.length < 1) {
        callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
      } else {
        var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("i18n_more_than0_two_decimal")));
        } else {
          callback();
        }
      }
    }
    const lwhValidate = (rule, value, callback) => {
      if (value > 250 || value <= 0) {
        callback(new Error(this.$t("i18n_cant_exceed_250_to_0_cm")));
      } else {
        // var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        //     if (!reg.test(value)) {
        //       callback(new Error("只能大于零且小于250cm"));
        //     } else
        //     {
        // 通过
        callback();
        // }
      }
    }
    return {
      addGoodsForm: {
        GoodsList: [
          {
            goodsname: '',
            namee: '',
            h: '',
            l: '',
            w: '',
            boxNum: '',
            weight: '',
            cbm: '',
            isBrand: false,
            isHasBattery: false,
            isPowderLiquid: false,
            goodstype: '',
            goodsTypeId: '',
            piece: '',
            // 单箱货值
            goodsValue: ''
          }
        ]
      },
      goodsInfoFormRules: {
        goodsname: [
          { required: true, message: this.cannotBeEmpty('i18n_product_name'), trigger: 'blur' }
        ],
        h: [
          { required: true, message: this.cannotBeEmpty('i18n_height1'), trigger: 'blur' },
          { validator: lwhValidate }
        ],
        l: [
          { required: true, message: this.cannotBeEmpty('i18n_length1'), trigger: 'blur' },
          { validator: lwhValidate }
        ],
        w: [
          { required: true, message: this.cannotBeEmpty('i18n_wide1'), trigger: 'blur' },
          { validator: lwhValidate }
        ],
        boxNum: [
          { required: true, message: this.cannotBeEmpty('i18n_carton_count'), trigger: 'blur' },
          { validator: pieceValidate }
        ],
        piece: [
          { required: true, message: this.cannotBeEmpty('i18n_pcs_count'), trigger: 'blur' },
          { validator: pieceValidate }
        ],
        weight: [
          { required: true, message: this.cannotBeEmpty('i18n_weight'), trigger: 'blur' },
          { validator: weightValidate }
        ],
        // cbm: [
        //   {required: true, message: '体积不能为空', trigger: 'blur'},
        //   {validator: cbmValidate}
        // ],
        isBrand: [
          { required: true, message: '请选择是否为品牌', trigger: 'change' }
        ],
        isHasBattery: [
          { required: true, message: '请选择是否带电', trigger: 'change' }
        ],
        isPowderLiquid: [
          { required: true, message: '请选择是否为液体粉末', trigger: 'change' }
        ],
        goodsTypeId: [
          { required: true, message: '请选择货物类型', trigger: 'change' }
        ]
        ,
        goodsValue: [
          { required: false, message: "请填写货值", trigger: 'blur' },
          { validator: valueValidate }
        ]
      }
    }
  },
  watch: {
    // goodsInfoForm: {
    //   deep: true,
    //   handler(val) {
    //     console.log(val)
    //     val.GoodsList.forEach((item, index) => {
    //       if (item.l&&item.h&&item.w) {
    //         item.cbm = parseFloat(item.l*item.h*item.w/1000000).toFixed(4)
    //         item.totalcbm = parseFloat(item.cbm*item.boxNum).toFixed(4)
    //         item.totalweight = parseFloat(item.weight*item.boxNum).toFixed(4)
    //       } else {
    //         item.cbm = 0
    //       }
    //     })
    //     this.$emit('change')
    //   }
    // }
  },
  methods: {
    getMoney() {
      this.$emit('change')
    },
    addItem() {
      this.$refs.goodsForm.validate(valid => {
        if (valid) {
          const obj = JSON.parse(JSON.stringify(this.addGoodsForm.GoodsList[0]))
          obj.goodsTypeId = this.goodsTypeOptions[0].goodsTypeId
          obj.goodsTypeName = this.goodsTypeOptions[0].goodsTypeName
          this.goodsInfoForm.GoodsList.push(obj)
          const arr = ['isBrand', 'isHasBattery', 'isPowderLiquid']
          Object.keys(this.addGoodsForm.GoodsList[0]).forEach(key => {
            if (arr.indexOf(key) === -1) {
              if (key == 'goodsValue') {
                this.addGoodsForm.GoodsList[0][key] = ''
              }
              this.addGoodsForm.GoodsList[0][key] = ''
            } else {
              this.addGoodsForm.GoodsList[0][key] = false
            }
          })
          this.$nextTick(() => {
            this.$refs.goodsForm.clearValidate()
          })
          this.$emit('change')
        }
      })
    },
    goodTypechange(id) {
      this.$emit('goodTypechange', id)
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('i18n_Total')
          return
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          const sumVal = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              if (index === 1) {
                return ''
              } else {
                return prev + curr
              }
            } else {
              return prev
            }
          }, 0)
          if (index === 7 || index === 8) {
            sums[index] = sumVal
          } else {
            sums[index] = Number(sumVal).toFixed(4)
          }
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    del(index) {
      this.$emit('del', index)
    },
    edit(index) {
      const obj = JSON.parse(JSON.stringify(this.goodsInfoForm.GoodsList[index]))
      this.addGoodsForm.GoodsList[0] = Object.assign(this.addGoodsForm.GoodsList[0], obj)
      this.$emit('edit', index)
    },
    cannotBeEmpty,
  }
}
</script>

<style lang="scss" scoped>
.small {
  /deep/.el-form {
    .el-form-item {
      margin-top: 25px;
      margin-bottom: 25px;
    }
    .el-form-item__content {
      .el-form-item__error {
        padding-top: 1px;
      }
    }
  }
}
.el-table {
  /deep/ td {
    padding-top: 0;
    padding-bottom: 0;
  }
  /deep/ .el-form-item__content {
    .el-input,
    .el-select {
      .el-input__inner {
        text-align: center;
        padding: 0;
      }
    }
  }
  /deep/ .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.weituo {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  .addMore {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }
}
.tittype {
  font-size: 18px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑,
    "Heiti SC";
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.el-button {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/component/goodsInfo.vue